module.exports = __webpack_public_path__ + "img/COMO_01.ea6846f8.jpg";